module.exports = __webpack_public_path__ + "img/profile_box_use_reasons.e9027610.svg";